import React, { Fragment } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import {
  APPLY_DATA_PATH,
  APPLY_ACTIVITY_PATH,
  APPLY_FINANCIAL_PATH,
  APPLY_ORGANIZATION_PATH
} from '../../../MainRoutes/constants'
import { stepStatuses } from '../../constants'

import withFormikStep from '../enhancers/withFormikStep'
import OrganizationStepNav from './StepNav'
import DataForm from './Forms/DataForm'
import ActivityForm from './Forms/ActivityForm'
import FinancialForm from './Forms/FinancialForm'

const EnhancedDataForm = withFormikStep({
  step: stepStatuses.DATA
})(DataForm)

const EnhancedActivityForm = withFormikStep({
  step: stepStatuses.ACTIVITY
})(ActivityForm)

const EnhancedFinancialForm = withFormikStep({
  step: stepStatuses.FINANCIAL
})(FinancialForm)

function ProjectRoutes() {
  return (
    <Fragment>
      <OrganizationStepNav />
      <Switch>
        <Route path={APPLY_DATA_PATH} component={EnhancedDataForm} exact />
        <Route path={APPLY_ACTIVITY_PATH} component={EnhancedActivityForm} exact />
        <Route path={APPLY_FINANCIAL_PATH} component={EnhancedFinancialForm} exact />
        <Redirect exact from={APPLY_ORGANIZATION_PATH} to={APPLY_DATA_PATH} />
      </Switch>
    </Fragment>
  )
}

export default ProjectRoutes
